/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Image, Space, Spin, Tooltip } from 'antd';
import { DownloadOutlined, EyeOutlined, FileOutlined, LoadingOutlined } from '@ant-design/icons';
import { downloadImage } from '../../../redux/fileSlice';

const DocumentComponent = ({ documentId }) => {
	const dispatch = useDispatch();

	const [fileUrl, setFileUrl] = useState(null);
	const [fileType, setFileType] = useState(null);
	const [makingApiCall, setMakingApiCall] = useState(false);

	useEffect(() => {
		let objectUrl = null;

		const fetchDocument = async () => {
			try {
				setMakingApiCall(true);

				const data = await dispatch(downloadImage(documentId)).unwrap();

				objectUrl = URL.createObjectURL(data);

				setFileUrl(objectUrl);
				setFileType(data.type);
			} catch (error) {
				console.log(error);
			} finally {
				setMakingApiCall(false);
			}
		};

		fetchDocument();

		return () => {
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}
		};
	}, [dispatch, documentId]);

	const isImage = fileType?.startsWith('image/');

	const handleView = () => {
		if (!fileUrl) return;

		window.open(fileUrl, '_blank', 'noopener,noreferrer');
	};

	const handleDownload = () => {
		if (!fileUrl) return;

		const link = document.createElement('a');

		link.href = fileUrl;
		link.download = `document-${documentId}`;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<Spin
			size='large'
			indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
			spinning={makingApiCall}>
			{fileUrl && (
				<div>
					{isImage ? (
						<Image
							src={fileUrl}
							width={80}
							height={80}
							style={{
								objectFit: 'cover',
								marginRight: '0.5em',
							}}
						/>
					) : (
						<Space>
							<FileOutlined />

							<Tooltip title='View document'>
								<Button type='text' icon={<EyeOutlined />} onClick={handleView} />
							</Tooltip>

							<Tooltip title='Download document'>
								<Button
									type='text'
									icon={<DownloadOutlined />}
									onClick={handleDownload}
								/>
							</Tooltip>
						</Space>
					)}
				</div>
			)}
		</Spin>
	);
};

export default DocumentComponent;
